/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FcbUserCentresLiesGridDtoPaginatedResults,
  FcbUsersCentresLiesDto,
  FilterCriteriaInfo,
  SelectItem,
  UsersCentresLiesSearch,
} from '../models/index';
import {
    FcbUserCentresLiesGridDtoPaginatedResultsFromJSON,
    FcbUserCentresLiesGridDtoPaginatedResultsToJSON,
    FcbUsersCentresLiesDtoFromJSON,
    FcbUsersCentresLiesDtoToJSON,
    FilterCriteriaInfoFromJSON,
    FilterCriteriaInfoToJSON,
    SelectItemFromJSON,
    SelectItemToJSON,
    UsersCentresLiesSearchFromJSON,
    UsersCentresLiesSearchToJSON,
} from '../models/index';

export interface UsersCentresLiesBaseSearchRequest {
    UsersCentresLiesSearch?: UsersCentresLiesSearch;
}

export interface UsersCentresLiesGetCentresRequest {
    idUser?: number;
}

export interface UsersCentresLiesGetSearchCriteriasRequest {
    includeListsValues?: boolean;
}

export interface UsersCentresLiesGetSelectItemsRequest {
    searchField: string;
}

export interface UsersCentresLiesSaveCentresRequest {
    FcbUsersCentresLiesDto?: FcbUsersCentresLiesDto;
}

/**
 * 
 */
export class UsersCentresLiesApi extends runtime.BaseAPI {

    /**
     */
    async usersCentresLiesBaseSearchRaw(requestParameters: UsersCentresLiesBaseSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FcbUserCentresLiesGridDtoPaginatedResults>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/UsersCentresLies/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UsersCentresLiesSearchToJSON(requestParameters.UsersCentresLiesSearch),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FcbUserCentresLiesGridDtoPaginatedResultsFromJSON(jsonValue));
    }

    /**
     */
    async usersCentresLiesBaseSearch(requestParameters: UsersCentresLiesBaseSearchRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FcbUserCentresLiesGridDtoPaginatedResults> {
        const response = await this.usersCentresLiesBaseSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async usersCentresLiesGetCentresRaw(requestParameters: UsersCentresLiesGetCentresRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FcbUsersCentresLiesDto>> {
        const queryParameters: any = {};

        if (requestParameters.idUser !== undefined) {
            queryParameters['idUser'] = requestParameters.idUser;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/UsersCentresLies`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FcbUsersCentresLiesDtoFromJSON(jsonValue));
    }

    /**
     */
    async usersCentresLiesGetCentres(requestParameters: UsersCentresLiesGetCentresRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FcbUsersCentresLiesDto> {
        const response = await this.usersCentresLiesGetCentresRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async usersCentresLiesGetSearchCriteriasRaw(requestParameters: UsersCentresLiesGetSearchCriteriasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FilterCriteriaInfo>>> {
        const queryParameters: any = {};

        if (requestParameters.includeListsValues !== undefined) {
            queryParameters['includeListsValues'] = requestParameters.includeListsValues;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/UsersCentresLies/criterias`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FilterCriteriaInfoFromJSON));
    }

    /**
     */
    async usersCentresLiesGetSearchCriterias(requestParameters: UsersCentresLiesGetSearchCriteriasRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FilterCriteriaInfo>> {
        const response = await this.usersCentresLiesGetSearchCriteriasRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async usersCentresLiesGetSelectItemsRaw(requestParameters: UsersCentresLiesGetSelectItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SelectItem>>> {
        if (requestParameters.searchField === null || requestParameters.searchField === undefined) {
            throw new runtime.RequiredError('searchField','Required parameter requestParameters.searchField was null or undefined when calling usersCentresLiesGetSelectItems.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/UsersCentresLies/criteriaList/{searchField}`.replace(`{${"searchField"}}`, encodeURIComponent(String(requestParameters.searchField))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SelectItemFromJSON));
    }

    /**
     */
    async usersCentresLiesGetSelectItems(requestParameters: UsersCentresLiesGetSelectItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SelectItem>> {
        const response = await this.usersCentresLiesGetSelectItemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async usersCentresLiesSaveCentresRaw(requestParameters: UsersCentresLiesSaveCentresRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/UsersCentresLies/save`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FcbUsersCentresLiesDtoToJSON(requestParameters.FcbUsersCentresLiesDto),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async usersCentresLiesSaveCentres(requestParameters: UsersCentresLiesSaveCentresRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.usersCentresLiesSaveCentresRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
